import React, { useEffect, useState } from "react";
import axios from "axios";
import { Spin, message } from "antd";

function Testimonials() {
  const [testimonials, setTestimonials] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchTestimonials();
  }, []);

  const fetchTestimonials = async () => {
    try {
      const response = await axios.get("http://93.127.203.113:5005/testimonials");
      setTestimonials(response.data);
    } catch (error) {
      message.error("Failed to fetch testimonials.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <section className="testimonials-section">
        <div className="container">
          <div className="testimonials-content">
            <div className="testimonials-content__title">
              <h4>Reviewed by People</h4>
              <h2>Client's Testimonials</h2>
              <p>
                Discover the positive impact we've made on our clients by reading through their testimonials.
                Our clients have experienced our service and results, and they're eager to share their
                positive experiences with you.
              </p>
            </div>

            {loading ? (
              <div className="loading-container">
                <Spin size="large" />
              </div>
            ) : (
              <div className="all-testimonials">
                <div className="testimonials-scroll">
                  {testimonials.length > 0 ? (
                    testimonials.map((testimonial) => (
                      <div key={testimonial.id} className="all-testimonials__box">
                        <span className="quotes-icon">
                          <i className="fa-solid fa-quote-right"></i>
                        </span>
                        <p className="testimonial-message">"{testimonial.message}"</p>
                        <div className="all-testimonials__box__name">
                          <div className="all-testimonials__box__name__profile">
                            <img
                              src={`http://93.127.203.113:5005${testimonial.image}`}
                              alt="user_img"
                            />
                            <span>
                              <h4>{testimonial.name}</h4>
                              <p>{testimonial.company}</p>
                            </span>
                          </div>
                        </div>
                      </div>
                    ))
                  ) : (
                    <p className="no-testimonials">No testimonials available.</p>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* 🌟 Styles for Larger Cards & Scrolling */}
      <style jsx>{`
        .testimonials-section {
          width: 100%;
          padding: 80px 20px;
          background-color: #f8f9fa;
        }

        .container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 20px;
        }

        .testimonials-content__title {
          text-align: center;
          margin-bottom: 40px;
        }

        .testimonials-content__title h4 {
          font-size: 1.9rem;
          color: #0c8c49;
          text-transform: uppercase;
          letter-spacing: 2px;
          margin-bottom: 10px;
        }

        .testimonials-content__title h2 {
          font-size: 3.5rem;
          color: #333;
          margin-bottom: 15px;
        }

        .testimonials-content__title p {
          font-size: 1.8rem;
          color: #555;
          max-width: 900px;
          margin: 0 auto;
        }

        /* 🌟 Horizontal Scroll with 2 Cards Visible */
        .all-testimonials {
          display: flex;
          overflow-x: auto;
          scroll-snap-type: x mandatory;
          white-space: nowrap;
          padding: 10px 0;
          justify-content: center;
        }

        .testimonials-scroll {
          display: flex;
          gap: 20px;
          overflow-x: auto;
          scroll-snap-type: x mandatory;
          padding: 10px;
          scrollbar-width: thin;
          scrollbar-color: #0c8c49 #f8f9fa;
        }

        .testimonials-scroll::-webkit-scrollbar {
          height: 8px;
        }

        .testimonials-scroll::-webkit-scrollbar-thumb {
          background-color: #0c8c49;
          border-radius: 10px;
        }

        .testimonials-scroll::-webkit-scrollbar-track {
          background-color: #f8f9fa;
        }

        /* 🟢 Larger Cards with Fixed Height */
        .all-testimonials__box {
          flex: 0 0 500px; /* 👈 Increased width */
          background-color: white;
          padding: 30px;
          border-radius: 10px;
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
          text-align: center;
          position: relative;
          scroll-snap-align: center;
          min-height: 280px; /* 👈 Ensures all cards have the same height */
          display: flex;
          flex-direction: column;
          justify-content: space-between;
        }

        .quotes-icon {
          font-size: 2rem;
          color: #0c8c49;
          position: absolute;
          top: 10px;
          right: 10px;
        }

        /* ✅ Prevents Message Overflow */
        .testimonial-message {
          font-size: 1.8rem;
          color: #333;
          font-style: italic;
          word-wrap: break-word;
          overflow-wrap: break-word;
          text-overflow: ellipsis;
          white-space: normal;
          max-height: 120px;
          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 5; /* Limits message to 5 lines */
          -webkit-box-orient: vertical;
        }

        .all-testimonials__box__name {
          margin-top: 10px;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .all-testimonials__box__name__profile {
          display: flex;
          align-items: center;
          gap: 15px;
        }

        .all-testimonials__box__name__profile img {
          width: 60px;
          height: 60px;
          border-radius: 50%;
          object-fit: cover;
        }

        .all-testimonials__box__name__profile span h4 {
          font-size: 1.8rem;
          font-weight: bold;
          color: #333;
        }

        .all-testimonials__box__name__profile span p {
          font-size: 1.5rem;
          color: #777;
        }

        .loading-container {
          display: flex;
          justify-content: center;
          align-items: center;
          height: 150px;
        }

        .no-testimonials {
          text-align: center;
          font-size: 1.8rem;
          color: #777;
        }

        @media (max-width: 768px) {
          .testimonials-content__title h2 {
            font-size: 3rem;
          }

          .all-testimonials__box {
            flex: 0 0 350px;
          }
        }

        @media (max-width: 480px) {
          .testimonials-section {
            padding: 60px 10px;
          }

          .testimonials-content__title h2 {
            font-size: 2.8rem;
          }

          .all-testimonials__box {
            flex: 0 0 300px;
          }
        }
      `}</style>
    </>
  );
}

export default Testimonials;
